import { z } from 'zod'
import { TokenDistributionPreview, TokenEmissionPreview } from './modeling.types'

export const ComparableProject = z.object({
  image: z.optional(z.string().nullable()),
  name: z.string(),
  FDV: z.number(),
  MC: z.number(),
})
export type ComparableProject = z.infer<typeof ComparableProject>
export const ComparableProjects = z.array(ComparableProject)
export type ComparableProjects = z.infer<typeof ComparableProjects>

export const Configurations = z.object({
  achieveFDVPercentage: z.number(),
  projectedFDV: z.number(),
  FDV: z.number(),
  MTS: z.number(),
})
export type Configurations = z.infer<typeof Configurations>

export const ComparableConfigurations = z.object({
  comparables: ComparableProjects,
  configurations: Configurations,
})
export type ComparableConfigurations = z.infer<typeof ComparableConfigurations>

// TODO sync with ui/pages/token-designer/valuation-documenting/sanitizing-tokens.vue until @forgd/common is pure
export const ProjectDetails = z.object({
  capitalRaised: z.number().nullable(),
  dateOfTge: z.string().min(1),
  fdvFromPreviousFundraising: z.number().nullable(),
  founderBio: z.string().nullable(),
  founderName: z.string().nullable(),
  officialWebsite: z.string().min(1),
  password: z.string().optional(),
  sector: z.string().min(1, 'Sector is required'),
  seniorTeamMembers: z.string().nullable(),
  summary: z.string().min(1, 'Summary is required'),
  typeOfMarketMaker: z.string().min(1, 'Type of market maker is required'),
  published: z.boolean().default(false),
})
export type ProjectDetails = z.infer<typeof ProjectDetails>

export const ValuationFieldsSchema = z.union([ComparableConfigurations, ProjectDetails])
export type ValuationFieldsSchema = z.infer<typeof ValuationFieldsSchema>

export const Valuation = z.object({
  distribution: TokenDistributionPreview,
  emissions: TokenEmissionPreview.nullable(),
})
export type Valuation = z.infer<typeof Valuation>

// Union of all modeling schemas
export const ValuationPreview = Valuation
export type ValuationPreview = z.infer<typeof ValuationPreview>

export const ValuationPreviewResponse = z.array(
  z.object({
    slug: z.string(),
    data: ValuationPreview.nullable(),
  }),
)

export type ValuationPreviewResponse = z.infer<typeof ValuationPreviewResponse>

export const PutValuationBody = z.object({
  subSectionId: z.string(),
  fields: z.unknown(),
})
